var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen",attrs:{"id":"presenter"}},[_c('div',{staticClass:"section",staticStyle:{"text-align":"center"}},[_c('p',[_vm._v("Use 'slideLocations'")]),_vm._v(" "),_c('v-btn',{staticClass:"button",on:{"click":_vm.uploadSlides}},[_vm._v("\n      Upload\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58b92a00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Upload.vue
// module id = null
// module chunks = 